import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, ref } from 'vue'

enum ActivityType { //活动类型
  '限时抢购' = 70,
  '拼团' = 75,
  '定金尾款' = 100,
}

enum FirstImageType { // 商品活动头图类型
  '活动图' = 1,
  '素材图' = 2,
  '商品原图' = 3,
}

interface IFirstImageInfo {
  activityType: ActivityType.限时抢购 | ActivityType.拼团 | ActivityType.定金尾款
  images: Array<string>
  firstImageType: FirstImageType.活动图 | FirstImageType.素材图 | FirstImageType.商品原图
  price: number // 价格
  minPrice: number | null // 多规格最低价格，xxx元起
  deductPrice: number | null // 抵扣价格
  startTimeStr: string
  endTimeStr: string
}

type PropsType = {
  type?: 'detail' | 'singleAndDoublePermutation' | 'flashSale' // 详情页 或 列表页 或 发现好货限时购列表
  firstImageInfo: IFirstImageInfo
}


export default /*#__PURE__*/_defineComponent({
  __name: 'actLabel',
  props: {
    type: { default: 'detail' },
    firstImageInfo: null
  },
  setup(__props: any) {

const props = __props as { type: 'detail' | 'singleAndDoublePermutation' | 'flashSale', firstImageInfo: IFirstImageInfo };



// props.firstImageInfo = {
//   activityType: 100,
//   images: ['http://sg-file-test.oss-cn-beijing.aliyuncs.com/product/php/image/2020/09/cb4bc3851e694e53f577c9d1e1dad0e9.jpg'],
//   firstImageType: 3,
//   price: 7000.89,
//   // minPrice: null,
//   minPrice: 1248.678,
//   deductPrice: 7010.67,
//   startTime: 1651038888,
//   startTimeStr: '4月27日',
//   endTime: 1672465980,
//   endTimeStr: '12月31日',
// }

const firstImageInfo = computed(() => {  return props.firstImageInfo })
/**
 * 文字图片路径后缀
 */
const activityType = ref(props.firstImageInfo?.activityType)
const titleType = activityType.value === ActivityType.限时抢购 ? 'qianggou' : activityType.value === ActivityType.拼团 ? 'pintuan' : 'dingjin'

/**
 * 当前组件的六种展示样式：
 * 限时抢购单规格-qianggou1
 * 限时抢购多规格-qianggouN
 * 定金尾款小于抵扣金额-dingjinL
 * 定金尾款大于等于抵扣金额-dingjinGE
 * 拼团单规格-pintuan1
 * 拼团多规格-pintuanN
 */
const activityLayoutType = computed(() => {
  switch (activityType.value) {
    case ActivityType.限时抢购:
      if (firstImageInfo.value.minPrice) return 'qianggouN'
      return 'qianggou1'
      break
    case ActivityType.定金尾款:
      if (firstImageInfo.value.price < firstImageInfo.value.deductPrice) return 'dingjinL'
      return 'dingjinGE'
      break
    case ActivityType.拼团:
      if (firstImageInfo.value.minPrice) return 'pintuanN'
      return 'pintuan1'
      break
    default:
      return 'qianggou1'
      break
  }
})


return { __sfc: true,ActivityType, FirstImageType, props, firstImageInfo, activityType, titleType, activityLayoutType }
}

})